import React, { Component } from "react";
import { connect } from "react-redux";
import { selectScheduleDate } from "ContentActions";
import { format, addDays, parse } from "date-fns";
import moment from "moment";

var monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

class ScheduleDateItem extends Component {
  onDateClick() {
    this.props.selectScheduleDate(this.props.date);
  }

  render() {
    var { date } = this.props;
    var scheduledate = `${date.scheduledate} 00:00:00`;

    // var now = new Date(scheduledate);
    // Works for safari and chrome both
    var now = parse(
      moment(scheduledate).format("DD-MM-YYYY HH:mm:ss"),
      "dd-MM-yyyy HH:mm:ss",
      new Date()
    );

    var strDate = now.getDate() + " " + monthNames[now.getMonth()];
    var styleClass = `list-group-item ${
      date.scheduledateid === this.props.selectedScheduleDate.scheduledateid
        ? "schedule-dates-li-selected"
        : "schedule-dates-li"
    }`;
    return (
      <li className={styleClass} onClick={this.onDateClick.bind(this)}>
        {strDate}
      </li>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedScheduleDate: state.selectedScheduleDate,
  };
}

export default connect(mapStateToProps, { selectScheduleDate })(
  ScheduleDateItem
);
